import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {finalize, first, take} from 'rxjs/operators';
import {UserService} from '../../../../services/user-services/user.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {SchoolService} from '../../../../services/school.service';
import {BirthdateDividedComponent} from '../../../../shared/components/ux/birthdate-divided/birthdate-divided.component';
import {CityInputComponent} from '../../../../shared/components/ux/inputs/city-input/city-input.component';
import {AuthenticationService} from '../../../../services/authentication.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ProcessService} from 'src/app/services/user-services/process.service';
import {DocumentsSharedService} from '../../../../services/documents-shared.service';
import {FormLoginComponent} from '../../../../shared/components/forms/login-register/form-login.component';
import {CheckFormErrorDirective} from '../../../../directives/checkFormError.directive';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {NgClass, NgFor, NgIf} from '@angular/common';
import {HubspotService} from "../../../../services/hubspot.service";
import {HelperService} from "../../../../services/helper.service";
import { LocalSettingsService } from 'src/app/services/local-settings.service';

@Component({
  selector: 'app-hc-component-form',
  templateUrl: './hc-component-form.component.html',
  styleUrls: ['./hc-component-form.component.scss'],
  standalone: true,
  imports: [NgIf, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule, NgClass, BirthdateDividedComponent, CityInputComponent, MatSelectModule, NgFor, MatOptionModule, CheckFormErrorDirective, FormLoginComponent, TranslateModule]
})
export class HcComponentFormComponent implements OnInit {

  @Input() isEdit = false;
  @Input() click = false;
  @Input() forcePage;
  @Output() private hasEdit: EventEmitter<string> = new EventEmitter<string>();
  @Output() private hasCompleteForm: EventEmitter<boolean> = new EventEmitter<boolean>();

  currentUser: any = null;
  locale = 'en';
  faculties: any[] = [];
  userFormattedAddress: any;
  isLoading = false;
  startingCities = [];
  form: UntypedFormGroup;
  isFormSubmit = false;
  isBirthdayCorrect = true;
  isArrivalDateCorrect = true;
  updateStatus: string = null;
  public errors = {'firstname': null, 'lastname': null, 'birthplace': null};
  public studyCity = null;
  isManualInput = false;

  @ViewChild('birthdateDividedComponent') private birthdateComponent: BirthdateDividedComponent;
  @ViewChild('ArrivalComponent') private ArrivalComponent: BirthdateDividedComponent;
  @ViewChild('cityInputComponent') private cityComponent: CityInputComponent;
  @ViewChild('CantDeliverDiv') private modalCantDeliver;

  isLogged = false;

  private birthCountry: string;
  additionalAddressFormControl: UntypedFormControl;
  fullHomeAddress;
  displayUnit = false;
  citySelected = false;
  public metropoleSelectIsOpen: boolean = false;
  public districtSelectIsOpen: boolean = false;
  public districtCities = [];

  constructor(
    private userService: UserService,
    private translateService: TranslateService,
    private schoolService: SchoolService,
    private fb: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    private router: Router,
    private ngbModal: NgbModal,
    private processService: ProcessService,
    private documentService: DocumentsSharedService,
    private hubspotService: HubspotService,
    private helperService: HelperService,
  ) {
  }

  ngOnInit(): void {

    this.locale = this.translateService.currentLang;
    this.getStartingCities();
    if (this.authenticationService.currentUserValue) {
      this.isLoading = true;
      this.isLogged = true;
      this.currentUser = this.userService.getInfos();
      this.birthCountry = this.currentUser.birthCountry;
      this.setForm(this.currentUser);
    }
  }

  public trackBy(index: number, item: any): number {
    return item.id ? item.id : index;
  }

  setInfos(event: any, type: string) {
    this.click = false;
    switch (type) {
      case 'city': {
        this.citySelected = false;
        if (event.formatted_address) {
          let replace = event.formatted_address.replace('-', ',')
          let split = replace.split(', ');
          if(split.length > 1){
            this.birthCountry = split[split.length - 1];
            split.splice(split.length - 1, 1);
          }
          this.form.controls.birthplace.setValue( split.join(', ').replace(/[0-9]/g, '').replace(/\s/g, ""));
          this.citySelected = true;
          this.fullHomeAddress = event.fullHomeAddress ? event.fullHomeAddress : null;
          this.form.controls.birthplace.setErrors(null);
        }
        else if(event && this.isManualInput === true) {
          this.form.controls.birthplace.setValue(event);
          this.citySelected = true;
          this.fullHomeAddress = event ? event : null;
          this.form.controls.birthplace.setErrors(null);
        }
        else {
          this.errors.birthplace = this.translateService.instant('COMMON.NOT_CLICK_IN_LIST');
          this.form.controls.birthplace.setErrors({'incorrect': true});
        }
        break;
      }
      case 'birthdate': {
        this.checkDate('birthdate', event, this.form.controls.birthdate);
        break;
      }
      case 'arrivalDate': {
        this.checkDate('arrivalDate', event, this.form.controls.arrivalDate);
        break;
      }
      case 'formattedAddress': {
        this.userFormattedAddress = this.fullHomeAddress = event;
        break;
      }

      case 'add' : {
        this.userFormattedAddress['additional'] = ' ' + event;
        break;
      }
    }
  }

  validateForm() {
    this.updateStatus = 'updating';
    this.isFormSubmit = true;
    if (!this.isNumber(this.form.value.studyPlace)) {
      this.form.controls.studyPlace.setErrors({'incorrect': true});
    }
    if (!this.citySelected) {
      this.form.controls.birthplace.setErrors({'incorrect': true});
    }
    if (this.birthdateComponent) {
      this.markAsTouched(this.birthdateComponent);
    }
    this.markAsTouched(this.ArrivalComponent);
    Object.keys(this.form.controls).forEach(c => {
      this.form.controls[c].markAsTouched();
    });
    if (this.form.valid && this.isArrivalDateCorrect && this.isBirthdayCorrect) {
      let hubspotDatas = {
        campagne: '',
        source: '',
        medium: ''
      };
      hubspotDatas = this.helperService.setUtmToHubspot(hubspotDatas);
      this.userService.setHubspotDeal(6459040, 19276179, hubspotDatas).subscribe();
      if (!this.isEdit && this.form.value.studyPlace) {
        this.processService.checkValidHousingCity(this.form.value.sector ? this.form.value.sector : this.form.value.studyPlace).subscribe((data) => {
          if (data) {
            this.updateUser();
            this.updateStatus = null;
          } else {
            this.updateStatus = null;
            this.ngbModal.open(this.modalCantDeliver);
          }
        });
      } else if (this.isEdit) {
        this.updateUser();
        this.updateStatus = null;
      }
    } else {
      this.updateStatus = null;
    }
  }

  getStartingCities() {
    this.startingCities = [];
    this.schoolService.getStartingElements().subscribe((data) => {
        this.startingCities = data.cities;
      }
    );
  }

  public checkLatin(field, e) {
    const regex = new RegExp('^[A-zÀ-ÿ0-9- \']+$');
    if (regex.test(e.target.value)) {
      if (this.errors[field] === 'undefined' || this.click === true) {
        this.errors[field] = null;
        this.form.controls[field].setErrors(null);
      }
    } else {
      this.errors[field] = this.translateService.instant('COMMON.ONLY_LATIN_ERROR');
      this.form.controls[field].setErrors({'incorrect': true});
    }
  }

  public hasBeenClick(e) {
    this.form.controls.birthplace.setErrors(null);
    this.errors.birthplace = null;
  }

  public checkCity(e): void {
    this.districtCities = [];

    this.studyCity = this.startingCities.find(c => c.id === e);
    if (this.studyCity.name === 'Lyon' || this.studyCity.name === 'Paris') {
      this.userService.getCitiesFromMetropole(e).pipe(first()).subscribe(data => {
        this.districtCities = data;
      });
    }
    if (!this.form.controls.sector) {
      if ((this.studyCity.name === 'Lyon' || this.studyCity.name === 'Paris')) {
        this.form.addControl('sector', new UntypedFormControl(null, Validators.required));
      }
    } else {
      this.form.controls.sector.patchValue(null);
    }
  }

  goto() {
    this.ngbModal.dismissAll();
    this.router.navigate(['discover']);
  }

  private setForm(data) {
    this.userFormattedAddress = {
      route: data.homeAddress,
      postal_code: data.postalCode,
      homeCity_id: data.homeCity_id,
      country: data.country,
    };
    this.additionalAddressFormControl = new UntypedFormControl(data.homeAdditionalAddress);

    this.form = this.fb.group({
      birthplace: [data.birthplace, Validators.required],
      stayDuration: [data.stayDuration, Validators.required],
      arrivalDate: [data.arrivalDate, Validators.required],
      firstname: [data.firstname, Validators.required],
      lastname: [data.lastname, Validators.required],
      studyPlace: [Validators.required],
    });

    if (data.birthplace) {
      this.citySelected = true;
    }

    this.form.addControl('birthdate', new UntypedFormControl(data.birthdate, Validators.required));
    let hubspotDatas = {
      campagne: '',
      source: '',
      medium: ''
    };
    hubspotDatas = this.helperService.setUtmToHubspot(hubspotDatas);
    this.userService.setHubspotDeal(6459040, 20579223, hubspotDatas).subscribe();
    if (!this.isEdit) {
      this.form.addControl('studyPlace', new UntypedFormControl(data.city_id ? data.city_id.toString() : null, Validators.required));
    }
    this.isLoading = false;
  }

  changeDisplayUnit() {
    this.displayUnit = !this.displayUnit;
  }

  private checkDate(type: string, event: any, fc: any) {
    if (event.yearControl && event.monthControl && event.dayControl) {
      const dateCheck = new Date(event.yearControl, event.monthControl - 1, event.dayControl);
      if (dateCheck.getFullYear() != event.yearControl || (dateCheck.getMonth() + 1) != event.monthControl || dateCheck.getDate() != event.dayControl) {
        if (type === 'birthdate') {
          this.isBirthdayCorrect = false;
        } else {
          this.isArrivalDateCorrect = false;
        }
      } else {
        if (type === 'birthdate') {
          this.isBirthdayCorrect = true;
        } else {
          this.isArrivalDateCorrect = true;
        }
        fc.setValue(dateCheck.getFullYear() + '-' + (dateCheck.getMonth() + 1) + '-' + dateCheck.getDate());
      }
    }
  }

  private updateUser() {
    this.currentUser.firstname = this.form.value.firstname;
    this.currentUser.lastname = this.form.value.lastname;
    this.currentUser.birthdate = this.form.value.birthdate;
    this.currentUser.birthplace = this.form.value.birthplace;

    let homeCityValue = null;
    if (this.userFormattedAddress.homeCity_id) {
      homeCityValue = this.userFormattedAddress.homeCity_id;
    } else {
      if (this.userFormattedAddress['city']) {
        homeCityValue = this.userFormattedAddress['city'].id;
      }
    }


    let selectedCity = this.currentUser.city;
    if (this.form.value.studyPlace && !this.form.value.sector) {
      const t = this.startingCities.filter(x => x.id == this.form.value.studyPlace)[0].name;
      if (t) {
        selectedCity = t;
      }
    } else {
      if (this.form.value.sector) {
        const secteur = this.districtCities.find(x => x.id == this.form.value.sector);
        if (secteur) {
          selectedCity = secteur.name;
        }
      }
    }


    this.userService.update({
      birthCountry: this.birthCountry,
      firstname: this.currentUser.firstname,
      lastname: this.currentUser.lastname,
      birthdate: this.currentUser.birthdate,
      birthplace: this.currentUser.birthplace,
      homeAddress: (this.userFormattedAddress['number'] ? this.userFormattedAddress['number'] + ' ' : '') + this.userFormattedAddress['route'],
      homeAdditionalAddress: this.userFormattedAddress['additional'] ? this.userFormattedAddress['additional'] : this.additionalAddressFormControl.value,
      homeCity_id: homeCityValue,
      postalCode: this.userFormattedAddress['postal_code'],
      country: this.userFormattedAddress['country'],
      city: selectedCity,
      city_id: this.form.value.sector ? this.form.value.sector : (this.form.value.studyPlace ? this.form.value.studyPlace : this.currentUser.city_id),
      fullHomeAddress: this.fullHomeAddress ? this.fullHomeAddress.fullHomeAddress : this.fullHomeAddress ? this.fullHomeAddress : null,
      stayDuration: this.form.value.stayDuration,
      arrivalDate: this.form.value.arrivalDate,
    }).pipe(first(), finalize(() => {
      if (this.currentUser.school_id === 53) {
        this.hubspotService.updateHubspot({
          studies_city: selectedCity,
        }).subscribe();
      }
      this.currentUser = this.userService.getInfos();
      if (this.isEdit) {
        this.updateStatus = 'pdfGen';
        this.documentService.genPdf('ATT_LGT').pipe(
          take(1),
          finalize(() => {
            this.hasEdit.emit('post-payment');
          })
        ).subscribe();

      } else {
        this.router.navigate(
          [this.translateService.currentLang + '/housing-certificate/confirmation'],
          { queryParams: { force: this.forcePage } }
        );
      }
    })).subscribe();
  }

  private markAsTouched(c) {
    c.yearControl.markAsTouched();
    c.monthControl.markAsTouched();
    c.dayControl.markAsTouched();
  }

  changeManualInput(){
    this.isManualInput = !this.isManualInput;
    this.citySelected = true;
    this.form.controls.birthplace.setErrors(null);
    this.errors.birthplace = null;
  }

  isNumber(value?: string | number): boolean
  {
    return ((value != null) &&
      (value !== '') &&
      !isNaN(Number(value.toString())));
  }

}
